// Shared axios `paramsSerializer` for endpoints that take REPEATABLE query keys.
//
// axios 0.26's default serializer renders an array as `key[]=a&key[]=b`. FastAPI
// binds a `list[str] = Query(...)` parameter only from repeated BARE keys
// (`key=a&key=b`) — the bracketed form arrives as an unknown param and is dropped,
// which fails silently: the request 200s with an UNFILTERED list. Any call site
// that sends an array must therefore pass this serializer.
//
// Empty values (undefined / null / "") are dropped entirely, so an unset filter is
// never sent and the endpoint keeps answering exactly as it does with no params.
export const serializeParams = (params: Record<string, unknown>): string => {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v !== undefined && v !== null && v !== "") sp.append(key, String(v));
      });
    } else {
      sp.append(key, String(value));
    }
  });

  return sp.toString();
};

export default serializeParams;
